webpackJsonp([1],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(101);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactRouter = __webpack_require__(6);
	
	var _routes = __webpack_require__(193);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _configureStore = __webpack_require__(194);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	__webpack_require__(199);
	
	var _reactRouterRedux = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable import/default */
	
	__webpack_require__(215); // Tell webpack to load favicon.ico
	// Yep, that's right. You can import SASS/CSS files too! Webpack will run the associated loader and plug this into the page.
	
	
	var store = (0, _configureStore2.default)();
	
	// Create an enhanced history that syncs navigation events with the store
	var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);
	
	(0, _reactDom.render)(_react2.default.createElement(
	  _reactRedux.Provider,
	  { store: store },
	  _react2.default.createElement(_reactRouter.Router, { history: history, routes: _routes2.default })
	), document.getElementById('app'));

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* baseReducer */
	var FETCH_BASE_START = exports.FETCH_BASE_START = 'FETCH_BASE_START';
	var FETCH_BASE_DONE = exports.FETCH_BASE_DONE = 'FETCH_BASE_DONE';
	var RECEIVE_BASE = exports.RECEIVE_BASE = 'RECEIVE_BASE';
	
	/* filmsReducer */
	var FETCH_FILMS_START = exports.FETCH_FILMS_START = 'FETCH_FILMS_START';
	var FETCH_FILMS_DONE = exports.FETCH_FILMS_DONE = 'FETCH_FILMS_DONE';
	var RECEIVE_FILMS = exports.RECEIVE_FILMS = 'RECEIVE_FILMS';
	var FETCH_FILM_START = exports.FETCH_FILM_START = 'FETCH_FILM_START';
	var FETCH_FILM_DONE = exports.FETCH_FILM_DONE = 'FETCH_FILM_DONE';
	var RECEIVE_FILM = exports.RECEIVE_FILM = 'RECEIVE_FILM';
	var FETCH_MORE_FILMS_START = exports.FETCH_MORE_FILMS_START = 'FETCH_MORE_FILMS_START';
	var FETCH_MORE_FILMS_DONE = exports.FETCH_MORE_FILMS_DONE = 'FETCH_MORE_FILMS_DONE';
	
	/* peopleReducer */
	var FETCH_PEOPLE_START = exports.FETCH_PEOPLE_START = 'FETCH_PEOPLE_START';
	var FETCH_PEOPLE_DONE = exports.FETCH_PEOPLE_DONE = 'FETCH_PEOPLE_DONE';
	var RECEIVE_PEOPLE = exports.RECEIVE_PEOPLE = 'RECEIVE_PEOPLE';
	var FETCH_PERSON_START = exports.FETCH_PERSON_START = 'FETCH_PERSON_START';
	var FETCH_PERSON_DONE = exports.FETCH_PERSON_DONE = 'FETCH_PERSON_DONE';
	var RECEIVE_PERSON = exports.RECEIVE_PERSON = 'RECEIVE_PERSON';
	var FETCH_MORE_PEOPLE_START = exports.FETCH_MORE_PEOPLE_START = 'FETCH_MORE_PEOPLE_START';
	var FETCH_MORE_PEOPLE_DONE = exports.FETCH_MORE_PEOPLE_DONE = 'FETCH_MORE_PEOPLE_DONE';
	var RECEIVE_MORE_PEOPLE = exports.RECEIVE_MORE_PEOPLE = 'RECEIVE_MORE_PEOPLE';
	
	/* planetsReducer */
	var FETCH_PLANETS_START = exports.FETCH_PLANETS_START = 'FETCH_PLANETS_START';
	var FETCH_PLANETS_DONE = exports.FETCH_PLANETS_DONE = 'FETCH_PLANETS_DONE';
	var RECEIVE_PLANETS = exports.RECEIVE_PLANETS = 'RECEIVE_PLANETS';
	var FETCH_PLANET_START = exports.FETCH_PLANET_START = 'FETCH_PLANET_START';
	var FETCH_PLANET_DONE = exports.FETCH_PLANET_DONE = 'FETCH_PLANET_DONE';
	var RECEIVE_PLANET = exports.RECEIVE_PLANET = 'RECEIVE_PLANET';
	
	/* speciesReducer */
	var FETCH_SPECIESES_START = exports.FETCH_SPECIESES_START = 'FETCH_SPECIESES_START';
	var FETCH_SPECIESES_DONE = exports.FETCH_SPECIESES_DONE = 'FETCH_SPECIESES_DONE';
	var RECEIVE_SPECIESES = exports.RECEIVE_SPECIESES = 'RECEIVE_SPECIESES';
	var FETCH_SPECIES_START = exports.FETCH_SPECIES_START = 'FETCH_SPECIES_START';
	var FETCH_SPECIES_DONE = exports.FETCH_SPECIES_DONE = 'FETCH_SPECIES_DONE';
	var RECEIVE_SPECIES = exports.RECEIVE_SPECIES = 'RECEIVE_SPECIES';
	
	/* starshipsReducer */
	var FETCH_STARSHIPS_START = exports.FETCH_STARSHIPS_START = 'FETCH_STARSHIPS_START';
	var FETCH_STARSHIPS_DONE = exports.FETCH_STARSHIPS_DONE = 'FETCH_STARSHIPS_DONE';
	var RECEIVE_STARSHIPS = exports.RECEIVE_STARSHIPS = 'RECEIVE_STARSHIPS';
	var FETCH_STARSHIP_START = exports.FETCH_STARSHIP_START = 'FETCH_STARSHIP_START';
	var FETCH_STARSHIP_DONE = exports.FETCH_STARSHIP_DONE = 'FETCH_STARSHIP_DONE';
	var RECEIVE_STARSHIP = exports.RECEIVE_STARSHIP = 'RECEIVE_STARSHIP';
	
	/* vehiclesReducer */
	var FETCH_VEHICLES_START = exports.FETCH_VEHICLES_START = 'FETCH_VEHICLES_START';
	var FETCH_VEHICLES_DONE = exports.FETCH_VEHICLES_DONE = 'FETCH_VEHICLES_DONE';
	var RECEIVE_VEHICLES = exports.RECEIVE_VEHICLES = 'RECEIVE_VEHICLES';
	var FETCH_VEHICLE_START = exports.FETCH_VEHICLE_START = 'FETCH_VEHICLE_START';
	var FETCH_VEHICLE_DONE = exports.FETCH_VEHICLE_DONE = 'FETCH_VEHICLE_DONE';
	var RECEIVE_VEHICLE = exports.RECEIVE_VEHICLE = 'RECEIVE_VEHICLE';

/***/ },
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Loader = function Loader(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "columns" },
	    _react2.default.createElement(
	      "div",
	      { className: "column" },
	      _react2.default.createElement(
	        "p",
	        { className: "notification is-" + (props.primary ? 'primary' : 'success') + " has-text-centered" },
	        props.primary ? 'Initializing data...' : 'Please wait...'
	      )
	    )
	  );
	};
	
	Loader.propTypes = {
	  primary: _react.PropTypes.bool
	};
	
	exports.default = Loader;

/***/ },
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DetailBack = function DetailBack(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'columns', style: { cursor: 'pointer', backgroundColor: '#df4747', color: '#fff' }, onClick: props.onClick },
	    _react2.default.createElement(
	      'div',
	      { className: 'column is-12' },
	      _react2.default.createElement(
	        'span',
	        { className: 'icon' },
	        _react2.default.createElement('i', { className: 'fa fa-angle-left' })
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'icon-caption' },
	        'Back'
	      )
	    )
	  );
	};
	
	DetailBack.propTypes = {
	  onClick: _react.PropTypes.func
	};
	
	exports.default = DetailBack;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stringHelper = __webpack_require__(87);
	
	var _stringHelper2 = _interopRequireDefault(_stringHelper);
	
	var _reactRedux = __webpack_require__(9);
	
	var _DetailItemLink = __webpack_require__(169);
	
	var _DetailItemLink2 = _interopRequireDefault(_DetailItemLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DetailItem = function DetailItem(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'columns', style: { backgroundColor: '#474747', color: '#fff' } },
	    _react2.default.createElement(
	      'div',
	      { className: 'column is-3' },
	      _react2.default.createElement(
	        'h5',
	        { className: 'title is-5', style: { color: '#fff' } },
	        props.title
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'column is-9' },
	      _typeof(props.data) === 'object' ? Object.keys(props.data).map(function (kk, i) {
	        return _react2.default.createElement(_DetailItemLink2.default, {
	          key: i,
	          to: '/' + _stringHelper2.default.getFullRoutes(props.data[kk]),
	          text: props.base[_stringHelper2.default.getRoutes(props.data[kk])][_stringHelper2.default.getRoutesId(props.data[kk])] });
	      }) : props.title === 'Homeworld' && typeof props.data !== 'undefined' ? _react2.default.createElement(_DetailItemLink2.default, {
	        to: '/' + _stringHelper2.default.getFullRoutes(props.data),
	        text: props.base[_stringHelper2.default.getRoutes(props.data)][_stringHelper2.default.getRoutesId(props.data)] }) : props.data
	    )
	  );
	};
	
	DetailItem.propTypes = {
	  base: _react.PropTypes.object,
	  title: _react.PropTypes.string,
	  data: _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.number, _react.PropTypes.string])
	};
	
	function mapStateToProps(state) {
	  return {
	    base: state.base
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(DetailItem);

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListHeader = function ListHeader(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'columns', style: { backgroundColor: '#df4747', color: '#fff', paddingLeft: 5, paddingRight: 5 } },
	    Object.keys(props.fields).map(function (field, i) {
	      return _react2.default.createElement(
	        'div',
	        { key: i, className: 'column' },
	        props.fields[field]
	      );
	    })
	  );
	};
	
	ListHeader.propTypes = {
	  fields: _react.PropTypes.object
	};
	
	exports.default = ListHeader;

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListItem = function ListItem(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'columns', style: { cursor: 'pointer', backgroundColor: '#474747', color: '#fff', borderBottom: 'solid 1px #fff' }, onClick: props.onClick.bind(undefined, props.id) },
	    _react2.default.createElement(
	      'div',
	      { className: 'column' },
	      props.name
	    )
	  );
	};
	
	ListItem.propTypes = {
	  onClick: _react.PropTypes.func,
	  id: _react.PropTypes.string,
	  name: _react.PropTypes.string
	};
	
	exports.default = ListItem;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListItemLoader = function ListItemLoader(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'columns', style: { backgroundColor: 'tomato', color: '#fff' } },
	    _react2.default.createElement(
	      'div',
	      { className: 'column' },
	      props.text
	    )
	  );
	};
	
	ListItemLoader.propTypes = {
	  text: _react.PropTypes.string
	};
	
	exports.default = ListItemLoader;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _axios = __webpack_require__(84);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(171);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RequestHelper = function () {
	  function RequestHelper() {
	    _classCallCheck(this, RequestHelper);
	  }
	
	  _createClass(RequestHelper, null, [{
	    key: 'request',
	    value: function request(payload) {
	      var instance = _axios2.default.create({
	        baseURL: _config.SWAPI_BASE_URL,
	        timeout: 20000
	      });
	
	      // Append '/' on url if url not end with '/' and doesnt have query strings
	      if (!payload.url.endsWith('/') && payload.url.indexOf('?') === -1) {
	        payload.url = payload.url + '/';
	      }
	
	      // Replace http with https
	      if (payload.url.search('https') === -1) {
	        payload.url.replace('http', 'https');
	      }
	
	      return instance.request(payload);
	    }
	  }]);
	
	  return RequestHelper;
	}();
	
	exports.default = RequestHelper;

/***/ },
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StringHelper = function () {
	  function StringHelper() {
	    _classCallCheck(this, StringHelper);
	  }
	
	  _createClass(StringHelper, null, [{
	    key: 'getRoutes',
	    value: function getRoutes(payload) {
	      return payload.split('/')[4];
	    }
	  }, {
	    key: 'getRoutesId',
	    value: function getRoutesId(payload) {
	      return payload.split('/')[5];
	    }
	  }, {
	    key: 'getFullRoutes',
	    value: function getFullRoutes(payload) {
	      return payload.split('/')[4] + '/' + payload.split('/')[5];
	    }
	  }]);
	
	  return StringHelper;
	}();
	
	exports.default = StringHelper;

/***/ },
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchBaseStart = fetchBaseStart;
	exports.fetchBaseDone = fetchBaseDone;
	exports.receiveBase = receiveBase;
	exports.fetchBase = fetchBase;
	
	var _actionTypes = __webpack_require__(11);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _firebase = __webpack_require__(93);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function fetchBaseStart() {
	  return {
	    type: types.FETCH_BASE_START
	  };
	}
	
	function fetchBaseDone() {
	  return {
	    type: types.FETCH_BASE_DONE
	  };
	}
	
	function receiveBase(base) {
	  return {
	    type: types.RECEIVE_BASE,
	    base: base
	  };
	}
	
	function fetchBase() {
	  return function (dispatch) {
	    dispatch(fetchBaseStart());
	
	    _firebase2.default.initializeApp({
	      apiKey: "AIzaSyBglHqGIR06X3AaJkriQH7MMgMeVMjl-iE",
	      authDomain: "swapii-5568e.firebaseapp.com",
	      databaseURL: "https://swapii-5568e.firebaseio.com",
	      storageBucket: "swapii-5568e.appspot.com"
	    });
	
	    _firebase2.default.database().ref().once('value').then(function (snapshot) {
	      dispatch(receiveBase(snapshot.val()));
	      dispatch(fetchBaseDone());
	    }).catch(function (res) {
	      console.log('Catch fetchBase: ', res); //eslint-disable-line
	      dispatch(fetchBaseDone());
	    });
	  };
	}

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchFilmsStart = fetchFilmsStart;
	exports.fetchFilmsDone = fetchFilmsDone;
	exports.receiveFilms = receiveFilms;
	exports.fetchFilms = fetchFilms;
	exports.fetchFilmStart = fetchFilmStart;
	exports.fetchFilmDone = fetchFilmDone;
	exports.receiveFilm = receiveFilm;
	exports.fetchFilm = fetchFilm;
	exports.fetchMoreFilmsStart = fetchMoreFilmsStart;
	exports.fetchMoreFilmsDone = fetchMoreFilmsDone;
	exports.fetchMoreFilms = fetchMoreFilms;
	
	var _actionTypes = __webpack_require__(11);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _requestHelper = __webpack_require__(34);
	
	var _requestHelper2 = _interopRequireDefault(_requestHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function fetchFilmsStart() {
	  return {
	    type: types.FETCH_FILMS_START
	  };
	}
	
	function fetchFilmsDone() {
	  return {
	    type: types.FETCH_FILMS_DONE
	  };
	}
	
	function receiveFilms(data) {
	  return {
	    type: types.RECEIVE_FILMS,
	    data: data
	  };
	}
	
	function fetchFilms() {
	  return function (dispatch) {
	    dispatch(fetchFilmsStart());
	
	    var payload = {
	      url: 'films'
	    };
	
	    _requestHelper2.default.request(payload).then(function (res) {
	      dispatch(fetchFilmsDone());
	      dispatch(receiveFilms(res.data));
	    }).catch(function (res) {
	      console.log('Catch fetchFilms: ', res); //eslint-disable-line
	    });
	  };
	}
	
	function fetchFilmStart() {
	  return {
	    type: types.FETCH_FILM_START
	  };
	}
	
	function fetchFilmDone() {
	  return {
	    type: types.FETCH_FILM_DONE
	  };
	}
	
	function receiveFilm(detail) {
	  return {
	    type: types.RECEIVE_FILM,
	    detail: detail
	  };
	}
	
	function fetchFilm(id) {
	  return function (dispatch) {
	    dispatch(fetchFilmStart());
	
	    var payload = {
	      url: 'films/' + id
	    };
	
	    _requestHelper2.default.request(payload).then(function (res) {
	      dispatch(fetchFilmDone());
	      dispatch(receiveFilm(res.data));
	    }).catch(function (res) {
	      console.log('Catch fetchFilm: ', res); //eslint-disable-line
	    });
	  };
	}
	
	function fetchMoreFilmsStart() {
	  return {
	    type: types.FETCH_MORE_FILMS_START
	  };
	}
	
	function fetchMoreFilmsDone() {
	  return {
	    type: types.FETCH_MORE_FILMS_DONE
	  };
	}
	
	function fetchMoreFilms() {
	  return function (dispatch, getState) {
	    var next = getState().films.data.next;
	    if (next === '' || next === null) {
	      dispatch(fetchMoreFilmsDone());
	    } else {
	      dispatch(fetchMoreFilmsStart());
	    }
	  };
	}

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchPeopleStart = fetchPeopleStart;
	exports.fetchPeopleDone = fetchPeopleDone;
	exports.receivePeople = receivePeople;
	exports.fetchPeople = fetchPeople;
	exports.fetchPersonStart = fetchPersonStart;
	exports.fetchPersonDone = fetchPersonDone;
	exports.receivePerson = receivePerson;
	exports.fetchPerson = fetchPerson;
	exports.fetchMorePeopleStart = fetchMorePeopleStart;
	exports.fetchMorePeopleDone = fetchMorePeopleDone;
	exports.receiveMorePeople = receiveMorePeople;
	exports.fetchMorePeople = fetchMorePeople;
	
	var _actionTypes = __webpack_require__(11);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _requestHelper = __webpack_require__(34);
	
	var _requestHelper2 = _interopRequireDefault(_requestHelper);
	
	var _stringHelper = __webpack_require__(87);
	
	var _stringHelper2 = _interopRequireDefault(_stringHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function fetchPeopleStart() {
	  return {
	    type: types.FETCH_PEOPLE_START
	  };
	}
	
	function fetchPeopleDone() {
	  return {
	    type: types.FETCH_PEOPLE_DONE
	  };
	}
	
	function receivePeople(data) {
	  return {
	    type: types.RECEIVE_PEOPLE,
	    data: data
	  };
	}
	
	function fetchPeople() {
	  return function (dispatch) {
	    dispatch(fetchPeopleStart());
	
	    var payload = {
	      method: 'get',
	      url: 'people'
	    };
	
	    _requestHelper2.default.request(payload).then(function (res) {
	      dispatch(fetchPeopleDone());
	      dispatch(receivePeople(res.data));
	    }).catch(function (res) {
	      console.log('Catch fetchPeople: ', res); //eslint-disable-line
	      dispatch(fetchPeopleDone());
	    });
	  };
	}
	
	function fetchPersonStart() {
	  return {
	    type: types.FETCH_PERSON_START
	  };
	}
	
	function fetchPersonDone() {
	  return {
	    type: types.FETCH_PERSON_DONE
	  };
	}
	
	function receivePerson(detail) {
	  return {
	    type: types.RECEIVE_PERSON,
	    detail: detail
	  };
	}
	
	function fetchPerson(id) {
	  return function (dispatch) {
	    dispatch(fetchPersonStart());
	
	    var payload = {
	      url: 'people/' + id
	    };
	
	    _requestHelper2.default.request(payload).then(function (res) {
	      dispatch(fetchPersonDone());
	      dispatch(receivePerson(res.data));
	    }).catch(function (res) {
	      console.log('Catch fetchPerson: ', res); //eslint-disable-line
	      dispatch(fetchPersonDone());
	    });
	  };
	}
	
	function fetchMorePeopleStart() {
	  return {
	    type: types.FETCH_MORE_PEOPLE_START
	  };
	}
	
	function fetchMorePeopleDone() {
	  return {
	    type: types.FETCH_MORE_PEOPLE_DONE
	  };
	}
	
	function receiveMorePeople(data) {
	  return {
	    type: types.RECEIVE_MORE_PEOPLE,
	    data: data
	  };
	}
	
	function fetchMorePeople() {
	  return function (dispatch, getState) {
	    var next = getState().people.data.next;
	    if (next === '' || next === null) {
	      dispatch(fetchMorePeopleDone());
	    } else {
	      dispatch(fetchMorePeopleStart());
	
	      var payload = {
	        url: _stringHelper2.default.getFullRoutes(next)
	      };
	      _requestHelper2.default.request(payload).then(function (res) {
	        dispatch(fetchMorePeopleDone());
	        dispatch(receiveMorePeople(res.data));
	      }).catch(function (res) {
	        console.log('Catch fetchMorePeople: ', res); //eslint-disable-line
	        dispatch(fetchMorePeopleDone());
	      });
	    }
	  };
	}

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchPlanetsStart = fetchPlanetsStart;
	exports.fetchPlanetsDone = fetchPlanetsDone;
	exports.receivePlanets = receivePlanets;
	exports.fetchPlanets = fetchPlanets;
	exports.fetchPlanetStart = fetchPlanetStart;
	exports.fetchPlanetDone = fetchPlanetDone;
	exports.receivePlanet = receivePlanet;
	exports.fetchPlanet = fetchPlanet;
	
	var _actionTypes = __webpack_require__(11);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _requestHelper = __webpack_require__(34);
	
	var _requestHelper2 = _interopRequireDefault(_requestHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function fetchPlanetsStart() {
	  return {
	    type: types.FETCH_PLANETS_START
	  };
	}
	
	function fetchPlanetsDone() {
	  return {
	    type: types.FETCH_PLANETS_DONE
	  };
	}
	
	function receivePlanets(data) {
	  return {
	    type: types.RECEIVE_PLANETS,
	    data: data
	  };
	}
	
	function fetchPlanets() {
	  return function (dispatch) {
	    dispatch(fetchPlanetsStart());
	
	    var payload = {
	      method: 'get',
	      url: 'planets'
	    };
	
	    _requestHelper2.default.request(payload).then(function (res) {
	      dispatch(fetchPlanetsDone());
	      dispatch(receivePlanets(res.data));
	    }).catch(function (res) {
	      console.log('Catch fetchPlanets: ', res); //eslint-disable-line
	    });
	  };
	}
	
	function fetchPlanetStart() {
	  return {
	    type: types.FETCH_PLANET_START
	  };
	}
	
	function fetchPlanetDone() {
	  return {
	    type: types.FETCH_PLANET_DONE
	  };
	}
	
	function receivePlanet(detail) {
	  return {
	    type: types.RECEIVE_PLANET,
	    detail: detail
	  };
	}
	
	function fetchPlanet(id) {
	  return function (dispatch) {
	    dispatch(fetchPlanetStart());
	
	    var payload = {
	      url: 'planets/' + id
	    };
	
	    _requestHelper2.default.request(payload).then(function (res) {
	      dispatch(fetchPlanetDone());
	      dispatch(receivePlanet(res.data));
	    }).catch(function (res) {
	      console.log('Catch fetchPlanet: ', res); //eslint-disable-line
	    });
	  };
	}

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchSpeciesesStart = fetchSpeciesesStart;
	exports.fetchSpeciesesDone = fetchSpeciesesDone;
	exports.receiveSpecieses = receiveSpecieses;
	exports.fetchSpecieses = fetchSpecieses;
	exports.fetchSpeciesStart = fetchSpeciesStart;
	exports.fetchSpeciesDone = fetchSpeciesDone;
	exports.receiveSpecies = receiveSpecies;
	exports.fetchSpecies = fetchSpecies;
	
	var _actionTypes = __webpack_require__(11);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _requestHelper = __webpack_require__(34);
	
	var _requestHelper2 = _interopRequireDefault(_requestHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function fetchSpeciesesStart() {
	  return {
	    type: types.FETCH_SPECIESES_START
	  };
	}
	
	function fetchSpeciesesDone() {
	  return {
	    type: types.FETCH_SPECIESES_DONE
	  };
	}
	
	function receiveSpecieses(data) {
	  return {
	    type: types.RECEIVE_SPECIESES,
	    data: data
	  };
	}
	
	function fetchSpecieses() {
	  return function (dispatch) {
	    dispatch(fetchSpeciesesStart());
	
	    var payload = {
	      method: 'get',
	      url: 'species'
	    };
	
	    _requestHelper2.default.request(payload).then(function (res) {
	      dispatch(fetchSpeciesesDone());
	      dispatch(receiveSpecieses(res.data));
	    }).catch(function (res) {
	      console.log('Catch fetchSpecieses: ', res); //eslint-disable-line
	    });
	  };
	}
	
	function fetchSpeciesStart() {
	  return {
	    type: types.FETCH_SPECIES_START
	  };
	}
	
	function fetchSpeciesDone() {
	  return {
	    type: types.FETCH_SPECIES_DONE
	  };
	}
	
	function receiveSpecies(detail) {
	  return {
	    type: types.RECEIVE_SPECIES,
	    detail: detail
	  };
	}
	
	function fetchSpecies(id) {
	  return function (dispatch) {
	    dispatch(fetchSpeciesStart());
	
	    var payload = {
	      url: 'species/' + id
	    };
	
	    _requestHelper2.default.request(payload).then(function (res) {
	      dispatch(fetchSpeciesDone());
	      dispatch(receiveSpecies(res.data));
	    }).catch(function (res) {
	      console.log('Catch fetchSpecies: ', res); //eslint-disable-line
	    });
	  };
	}

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchStarshipsStart = fetchStarshipsStart;
	exports.fetchStarshipsDone = fetchStarshipsDone;
	exports.receiveStarships = receiveStarships;
	exports.fetchStarships = fetchStarships;
	exports.fetchStarshipStart = fetchStarshipStart;
	exports.fetchStarshipDone = fetchStarshipDone;
	exports.receiveStarship = receiveStarship;
	exports.fetchStarship = fetchStarship;
	
	var _actionTypes = __webpack_require__(11);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _requestHelper = __webpack_require__(34);
	
	var _requestHelper2 = _interopRequireDefault(_requestHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function fetchStarshipsStart() {
	  return {
	    type: types.FETCH_STARSHIPS_START
	  };
	}
	
	function fetchStarshipsDone() {
	  return {
	    type: types.FETCH_STARSHIPS_DONE
	  };
	}
	
	function receiveStarships(data) {
	  return {
	    type: types.RECEIVE_STARSHIPS,
	    data: data
	  };
	}
	
	function fetchStarships() {
	  return function (dispatch) {
	    dispatch(fetchStarshipsStart());
	
	    var payload = {
	      method: 'get',
	      url: 'starships'
	    };
	
	    _requestHelper2.default.request(payload).then(function (res) {
	      dispatch(fetchStarshipsDone());
	      dispatch(receiveStarships(res.data));
	    }).catch(function (res) {
	      console.log('Catch fetchStarships: ', res); //eslint-disable-line
	    });
	  };
	}
	
	function fetchStarshipStart() {
	  return {
	    type: types.FETCH_STARSHIP_START
	  };
	}
	
	function fetchStarshipDone() {
	  return {
	    type: types.FETCH_STARSHIP_DONE
	  };
	}
	
	function receiveStarship(detail) {
	  return {
	    type: types.RECEIVE_STARSHIP,
	    detail: detail
	  };
	}
	
	function fetchStarship(id) {
	  return function (dispatch) {
	    dispatch(fetchStarshipStart());
	
	    var payload = {
	      url: 'starships/' + id
	    };
	
	    _requestHelper2.default.request(payload).then(function (res) {
	      dispatch(fetchStarshipDone());
	      dispatch(receiveStarship(res.data));
	    }).catch(function (res) {
	      console.log('Catch fetchStarship: ', res); //eslint-disable-line
	    });
	  };
	}

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchVehiclesStart = fetchVehiclesStart;
	exports.fetchVehiclesDone = fetchVehiclesDone;
	exports.receiveVehicles = receiveVehicles;
	exports.fetchVehicles = fetchVehicles;
	exports.fetchVehicleStart = fetchVehicleStart;
	exports.fetchVehicleDone = fetchVehicleDone;
	exports.receiveVehicle = receiveVehicle;
	exports.fetchVehicle = fetchVehicle;
	
	var _actionTypes = __webpack_require__(11);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _requestHelper = __webpack_require__(34);
	
	var _requestHelper2 = _interopRequireDefault(_requestHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function fetchVehiclesStart() {
	  return {
	    type: types.FETCH_VEHICLES_START
	  };
	}
	
	function fetchVehiclesDone() {
	  return {
	    type: types.FETCH_VEHICLES_DONE
	  };
	}
	
	function receiveVehicles(data) {
	  return {
	    type: types.RECEIVE_VEHICLES,
	    data: data
	  };
	}
	
	function fetchVehicles() {
	  return function (dispatch) {
	    dispatch(fetchVehiclesStart());
	
	    var payload = {
	      method: 'get',
	      url: 'vehicles'
	    };
	
	    _requestHelper2.default.request(payload).then(function (res) {
	      dispatch(fetchVehiclesDone());
	      dispatch(receiveVehicles(res.data));
	    }).catch(function (res) {
	      console.log('Catch fetchVehicles: ', res); //eslint-disable-line
	    });
	  };
	}
	
	function fetchVehicleStart() {
	  return {
	    type: types.FETCH_VEHICLE_START
	  };
	}
	
	function fetchVehicleDone() {
	  return {
	    type: types.FETCH_VEHICLE_DONE
	  };
	}
	
	function receiveVehicle(detail) {
	  return {
	    type: types.RECEIVE_VEHICLE,
	    detail: detail
	  };
	}
	
	function fetchVehicle(id) {
	  return function (dispatch) {
	    dispatch(fetchVehicleStart());
	
	    var payload = {
	      url: 'vehicles/' + id
	    };
	
	    _requestHelper2.default.request(payload).then(function (res) {
	      dispatch(fetchVehicleDone());
	      dispatch(receiveVehicle(res.data));
	    }).catch(function (res) {
	      console.log('Catch fetchVehicle: ', res); //eslint-disable-line
	    });
	  };
	}

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DetailItemLink = function DetailItemLink(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactRouter.Link,
	      { to: props.to },
	      props.text
	    )
	  );
	};
	
	DetailItemLink.propTypes = {
	  to: _react.PropTypes.string,
	  text: _react.PropTypes.string
	};
	
	exports.default = DetailItemLink;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFoundPage = function NotFoundPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h4',
	      null,
	      '404 Page Not Found'
	    ),
	    _react2.default.createElement(
	      _reactRouter.Link,
	      { to: '/' },
	      ' Go back to homepage '
	    )
	  );
	};
	
	exports.default = NotFoundPage;

/***/ },
/* 171 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SWAPI_BASE_URL = exports.SWAPI_BASE_URL = 'https://swapi.co/api/';

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(6);
	
	var _reactRedux = __webpack_require__(9);
	
	var _baseActions = __webpack_require__(162);
	
	var _Loader = __webpack_require__(24);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var logo = __webpack_require__(214);
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App(props) {
	    _classCallCheck(this, App);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(App).call(this, props));
	
	    _this.state = {
	      isMenuOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(App, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.dispatch((0, _baseActions.fetchBase)());
	    }
	  }, {
	    key: 'onToggleMenu',
	    value: function onToggleMenu() {
	      this.setState({
	        isMenuOpen: !this.state.isMenuOpen
	      });
	    }
	  }, {
	    key: 'onMenuClick',
	    value: function onMenuClick(e) {
	      var pathname = e.target.getAttribute('to');
	      this.setState({
	        isMenuOpen: false
	      }, function () {
	        _reactRouter.browserHistory.replace({
	          pathname: pathname
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.base.isFetching) {
	        return _react2.default.createElement(_Loader2.default, { primary: true });
	      } else {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'nav',
	            { className: 'nav' },
	            _react2.default.createElement(
	              'div',
	              { className: 'nav-left' },
	              _react2.default.createElement(
	                'a',
	                { className: 'nav-item', href: '#' },
	                _react2.default.createElement('img', { src: logo, alt: 'Bulma logo' })
	              )
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'nav-toggle', onClick: this.onToggleMenu.bind(this) },
	              _react2.default.createElement('span', null),
	              _react2.default.createElement('span', null),
	              _react2.default.createElement('span', null)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'nav-right nav-menu ' + (this.state.isMenuOpen ? 'is-active' : '') },
	              _react2.default.createElement(
	                'a',
	                { className: 'nav-item', to: '/films', onClick: this.onMenuClick.bind(this) },
	                'Films'
	              ),
	              _react2.default.createElement(
	                'a',
	                { className: 'nav-item', to: '/people', onClick: this.onMenuClick.bind(this) },
	                'People'
	              ),
	              _react2.default.createElement(
	                'a',
	                { className: 'nav-item', to: '/planets', onClick: this.onMenuClick.bind(this) },
	                'Planets'
	              ),
	              _react2.default.createElement(
	                'a',
	                { className: 'nav-item', to: '/species', onClick: this.onMenuClick.bind(this) },
	                'Species'
	              ),
	              _react2.default.createElement(
	                'a',
	                { className: 'nav-item', to: '/starships', onClick: this.onMenuClick.bind(this) },
	                'Starships'
	              ),
	              _react2.default.createElement(
	                'a',
	                { className: 'nav-item', to: '/vehicles', onClick: this.onMenuClick.bind(this) },
	                'Vehicles'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'wrapper' },
	            this.props.children
	          )
	        );
	      }
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	App.propTypes = {
	  base: _react.PropTypes.object,
	  children: _react.PropTypes.element,
	  dispatch: _react.PropTypes.func
	};
	
	function mapStateToProps(state) {
	  return {
	    base: state.base
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(App);

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Film = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactRouter = __webpack_require__(6);
	
	var _filmsActions = __webpack_require__(163);
	
	var _DetailBack = __webpack_require__(29);
	
	var _DetailBack2 = _interopRequireDefault(_DetailBack);
	
	var _DetailItem = __webpack_require__(30);
	
	var _DetailItem2 = _interopRequireDefault(_DetailItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Film = exports.Film = function (_Component) {
	  _inherits(Film, _Component);
	
	  function Film(props) {
	    _classCallCheck(this, Film);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Film).call(this, props));
	
	    _this.fields = {
	      title: 'Title',
	      episode_id: 'Episode',
	      opening_crawl: 'Description',
	      director: 'Director',
	      producer: 'Producer',
	      release_date: 'Release Date',
	      characters: 'Characters',
	      planets: 'Planets',
	      starships: 'Starships',
	      vehicles: 'Vehicles',
	      species: 'Species'
	    };
	    return _this;
	  }
	
	  _createClass(Film, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var id = this.props.routeParams.id;
	
	      this.props.dispatch((0, _filmsActions.fetchFilm)(id));
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      _reactRouter.browserHistory.goBack();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (this.props.films.isFetching) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          'Loading film data...'
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'film' },
	          _react2.default.createElement(_DetailBack2.default, { onClick: this.goBack }),
	          Object.keys(this.fields).map(function (k, i) {
	            return _react2.default.createElement(_DetailItem2.default, {
	              key: i,
	              data: _this2.props.films.detail[k],
	              title: _this2.fields[k] });
	          })
	        );
	      }
	    }
	  }]);
	
	  return Film;
	}(_react.Component);
	
	Film.propTypes = {
	  routeParams: _react.PropTypes.object,
	  dispatch: _react.PropTypes.func,
	  films: _react.PropTypes.object
	};
	
	function mapStateToProps(state) {
	  return {
	    films: state.films
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Film);

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Films = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactRouter = __webpack_require__(6);
	
	var _reactInfinite = __webpack_require__(26);
	
	var _reactInfinite2 = _interopRequireDefault(_reactInfinite);
	
	var _ListHeader = __webpack_require__(31);
	
	var _ListHeader2 = _interopRequireDefault(_ListHeader);
	
	var _ListItem = __webpack_require__(32);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _ListItemLoader = __webpack_require__(33);
	
	var _ListItemLoader2 = _interopRequireDefault(_ListItemLoader);
	
	var _Loader = __webpack_require__(24);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Films = exports.Films = function (_Component) {
	  _inherits(Films, _Component);
	
	  function Films(props) {
	    _classCallCheck(this, Films);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Films).call(this, props));
	
	    _this.fields = {
	      name: 'Name'
	    };
	
	    _this.state = {
	      isFetchingMore: false,
	      current: 1,
	      maxItem: 20
	    };
	    return _this;
	  }
	
	  _createClass(Films, [{
	    key: 'onRowClick',
	    value: function onRowClick(id) {
	      _reactRouter.browserHistory.push({
	        pathname: 'films/' + id
	      });
	    }
	  }, {
	    key: 'onInfiniteLoad',
	    value: function onInfiniteLoad() {
	      var _this2 = this;
	
	      if (this.props.base.films.length > this.state.maxItem * this.state.current) {
	        this.setState({
	          isFetchingMore: true
	        }, function () {
	          setTimeout(function () {
	            _this2.setState({
	              current: _this2.state.current + 1,
	              isFetchingMore: false
	            });
	          }, 1000);
	        });
	      } else {
	        this.setState({
	          isFetchingMore: false
	        });
	      }
	    }
	  }, {
	    key: 'getLoader',
	    value: function getLoader() {
	      return _react2.default.createElement(_ListItemLoader2.default, { text: 'Loading more films...' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      if (this.props.base.isFetching) {
	        return _react2.default.createElement(_Loader2.default, null);
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'films' },
	          _react2.default.createElement(_ListHeader2.default, { fields: this.fields }),
	          _react2.default.createElement(
	            _reactInfinite2.default,
	            {
	              containerHeight: 500,
	              infiniteLoadBeginEdgeOffset: 200,
	              elementHeight: 40,
	              className: 'infiniteScrollContainer',
	              useWindowAsScrollContainer: true,
	              onInfiniteLoad: this.onInfiniteLoad.bind(this),
	              loadingSpinnerDelegate: this.getLoader(),
	              isInfiniteLoading: this.state.isFetchingMore
	            },
	            Object.keys(this.props.base.films).filter(function (film, i) {
	              return i < _this3.state.maxItem * _this3.state.current;
	            }).map(function (film, i) {
	              return _react2.default.createElement(_ListItem2.default, { key: i, fields: _this3.fields, id: film, name: _this3.props.base.films[film], onClick: _this3.onRowClick.bind(_this3) });
	            })
	          )
	        );
	      }
	    }
	  }]);
	
	  return Films;
	}(_react.Component);
	
	Films.propTypes = {
	  base: _react.PropTypes.object
	};
	
	function mapStateToProps(state) {
	  return {
	    base: state.base
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Films);

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.People = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactRouter = __webpack_require__(6);
	
	var _reactInfinite = __webpack_require__(26);
	
	var _reactInfinite2 = _interopRequireDefault(_reactInfinite);
	
	var _ListHeader = __webpack_require__(31);
	
	var _ListHeader2 = _interopRequireDefault(_ListHeader);
	
	var _ListItem = __webpack_require__(32);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _ListItemLoader = __webpack_require__(33);
	
	var _ListItemLoader2 = _interopRequireDefault(_ListItemLoader);
	
	var _Loader = __webpack_require__(24);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var People = exports.People = function (_Component) {
	  _inherits(People, _Component);
	
	  function People(props) {
	    _classCallCheck(this, People);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(People).call(this, props));
	
	    _this.fields = {
	      name: 'Name'
	    };
	
	    _this.state = {
	      isFetchingMore: false,
	      current: 1,
	      maxItem: 20
	    };
	    return _this;
	  }
	
	  _createClass(People, [{
	    key: 'onRowClick',
	    value: function onRowClick(id) {
	      _reactRouter.browserHistory.push({
	        pathname: 'people/' + id
	      });
	    }
	  }, {
	    key: 'onInfiniteLoad',
	    value: function onInfiniteLoad() {
	      var _this2 = this;
	
	      if (this.props.base.people.length > this.state.maxItem * this.state.current) {
	        this.setState({
	          isFetchingMore: true
	        }, function () {
	          setTimeout(function () {
	            _this2.setState({
	              current: _this2.state.current + 1,
	              isFetchingMore: false
	            });
	          }, 1000);
	        });
	      } else {
	        this.setState({
	          isFetchingMore: false
	        });
	      }
	    }
	  }, {
	    key: 'getLoader',
	    value: function getLoader() {
	      return _react2.default.createElement(_ListItemLoader2.default, { text: 'Loading more people...' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      if (this.props.base.isFetching) {
	        return _react2.default.createElement(_Loader2.default, null);
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'people' },
	          _react2.default.createElement(_ListHeader2.default, { fields: this.fields }),
	          _react2.default.createElement(
	            _reactInfinite2.default,
	            {
	              containerHeight: 500,
	              infiniteLoadBeginEdgeOffset: 200,
	              elementHeight: 40,
	              className: 'infiniteScrollContainer',
	              useWindowAsScrollContainer: true,
	              onInfiniteLoad: this.onInfiniteLoad.bind(this),
	              loadingSpinnerDelegate: this.getLoader(),
	              isInfiniteLoading: this.state.isFetchingMore
	            },
	            Object.keys(this.props.base.people).filter(function (person, i) {
	              return i < _this3.state.maxItem * _this3.state.current;
	            }).map(function (person, i) {
	              return _react2.default.createElement(_ListItem2.default, { key: i, fields: _this3.fields, id: person, name: _this3.props.base.people[person], onClick: _this3.onRowClick.bind(_this3) });
	            })
	          )
	        );
	      }
	    }
	  }]);
	
	  return People;
	}(_react.Component);
	
	People.propTypes = {
	  base: _react.PropTypes.object
	};
	
	function mapStateToProps(state) {
	  return {
	    base: state.base
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(People);

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Person = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactRouter = __webpack_require__(6);
	
	var _peopleActions = __webpack_require__(164);
	
	var _DetailBack = __webpack_require__(29);
	
	var _DetailBack2 = _interopRequireDefault(_DetailBack);
	
	var _DetailItem = __webpack_require__(30);
	
	var _DetailItem2 = _interopRequireDefault(_DetailItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Person = exports.Person = function (_Component) {
	  _inherits(Person, _Component);
	
	  function Person(props) {
	    _classCallCheck(this, Person);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Person).call(this, props));
	
	    _this.fields = {
	      name: 'Name',
	      height: 'Height',
	      mass: 'Mass',
	      hair_color: 'Hair Color',
	      skin_color: 'Skin Color',
	      eye_color: 'Eye Color',
	      birth_year: 'Birth Year',
	      gender: 'Gender',
	      homeworld: 'Homeworld',
	      films: 'Films',
	      species: 'Species',
	      vehicles: 'Vehicles',
	      starships: 'Starships'
	    };
	    return _this;
	  }
	
	  _createClass(Person, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var id = this.props.routeParams.id;
	
	      this.props.dispatch((0, _peopleActions.fetchPerson)(id));
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      _reactRouter.browserHistory.goBack();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (this.props.people.isFetching) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          'Loading person data...'
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'person' },
	          _react2.default.createElement(_DetailBack2.default, { onClick: this.goBack }),
	          Object.keys(this.fields).map(function (k, i) {
	            return _react2.default.createElement(_DetailItem2.default, {
	              key: i,
	              data: _this2.props.people.detail[k],
	              title: _this2.fields[k] });
	          })
	        );
	      }
	    }
	  }]);
	
	  return Person;
	}(_react.Component);
	
	Person.propTypes = {
	  routeParams: _react.PropTypes.object,
	  dispatch: _react.PropTypes.func,
	  people: _react.PropTypes.object
	};
	
	function mapStateToProps(state) {
	  return {
	    people: state.people
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Person);

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Planet = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactRouter = __webpack_require__(6);
	
	var _planetsActions = __webpack_require__(165);
	
	var _DetailBack = __webpack_require__(29);
	
	var _DetailBack2 = _interopRequireDefault(_DetailBack);
	
	var _DetailItem = __webpack_require__(30);
	
	var _DetailItem2 = _interopRequireDefault(_DetailItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Planet = exports.Planet = function (_Component) {
	  _inherits(Planet, _Component);
	
	  function Planet(props) {
	    _classCallCheck(this, Planet);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Planet).call(this, props));
	
	    _this.fields = {
	      name: 'Name',
	      rotation_period: 'Rotation Period',
	      orbital_period: 'Orbital Period',
	      diameter: 'Diameter',
	      climate: 'Climate',
	      gravity: 'Gravity',
	      terrain: 'Terrain',
	      surface_water: 'Surface Water',
	      population: 'Population',
	      residents: 'Residents',
	      films: 'Films'
	    };
	    return _this;
	  }
	
	  _createClass(Planet, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var id = this.props.routeParams.id;
	
	      this.props.dispatch((0, _planetsActions.fetchPlanet)(id));
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      _reactRouter.browserHistory.goBack();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (this.props.planets.isFetching) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          'Loading planet data...'
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'planet' },
	          _react2.default.createElement(_DetailBack2.default, { onClick: this.goBack }),
	          Object.keys(this.fields).map(function (k, i) {
	            return _react2.default.createElement(_DetailItem2.default, {
	              key: i,
	              data: _this2.props.planets.detail[k],
	              title: _this2.fields[k] });
	          })
	        );
	      }
	    }
	  }]);
	
	  return Planet;
	}(_react.Component);
	
	Planet.propTypes = {
	  routeParams: _react.PropTypes.object,
	  dispatch: _react.PropTypes.func,
	  planets: _react.PropTypes.object
	};
	
	function mapStateToProps(state) {
	  return {
	    planets: state.planets
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Planet);

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Planets = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactRouter = __webpack_require__(6);
	
	var _reactInfinite = __webpack_require__(26);
	
	var _reactInfinite2 = _interopRequireDefault(_reactInfinite);
	
	var _ListHeader = __webpack_require__(31);
	
	var _ListHeader2 = _interopRequireDefault(_ListHeader);
	
	var _ListItem = __webpack_require__(32);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _ListItemLoader = __webpack_require__(33);
	
	var _ListItemLoader2 = _interopRequireDefault(_ListItemLoader);
	
	var _Loader = __webpack_require__(24);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Planets = exports.Planets = function (_Component) {
	  _inherits(Planets, _Component);
	
	  function Planets(props) {
	    _classCallCheck(this, Planets);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Planets).call(this, props));
	
	    _this.fields = {
	      name: 'Name'
	    };
	
	    _this.state = {
	      isFetchingMore: false,
	      current: 1,
	      maxItem: 20
	    };
	    return _this;
	  }
	
	  _createClass(Planets, [{
	    key: 'onRowClick',
	    value: function onRowClick(id) {
	      _reactRouter.browserHistory.push({
	        pathname: 'planets/' + id
	      });
	    }
	  }, {
	    key: 'onInfiniteLoad',
	    value: function onInfiniteLoad() {
	      var _this2 = this;
	
	      if (this.props.base.planets.length > this.state.maxItem * this.state.current) {
	        this.setState({
	          isFetchingMore: true
	        }, function () {
	          setTimeout(function () {
	            _this2.setState({
	              current: _this2.state.current + 1,
	              isFetchingMore: false
	            });
	          }, 1000);
	        });
	      } else {
	        this.setState({
	          isFetchingMore: false
	        });
	      }
	    }
	  }, {
	    key: 'getLoader',
	    value: function getLoader() {
	      return _react2.default.createElement(_ListItemLoader2.default, { text: 'Loading more planets...' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      if (this.props.base.isFetching) {
	        return _react2.default.createElement(_Loader2.default, null);
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'planets' },
	          _react2.default.createElement(_ListHeader2.default, { fields: this.fields }),
	          _react2.default.createElement(
	            _reactInfinite2.default,
	            {
	              containerHeight: 500,
	              infiniteLoadBeginEdgeOffset: 200,
	              elementHeight: 40,
	              className: 'infiniteScrollContainer',
	              useWindowAsScrollContainer: true,
	              onInfiniteLoad: this.onInfiniteLoad.bind(this),
	              loadingSpinnerDelegate: this.getLoader(),
	              isInfiniteLoading: this.state.isFetchingMore
	            },
	            Object.keys(this.props.base.planets).filter(function (planet, i) {
	              return i < _this3.state.maxItem * _this3.state.current;
	            }).map(function (planet, i) {
	              return _react2.default.createElement(_ListItem2.default, { key: i, fields: _this3.fields, id: planet, name: _this3.props.base.planets[planet], onClick: _this3.onRowClick.bind(_this3) });
	            })
	          )
	        );
	      }
	    }
	  }]);
	
	  return Planets;
	}(_react.Component);
	
	Planets.propTypes = {
	  base: _react.PropTypes.object
	};
	
	function mapStateToProps(state) {
	  return {
	    base: state.base
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Planets);

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Species = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactRouter = __webpack_require__(6);
	
	var _speciesesActions = __webpack_require__(166);
	
	var _DetailBack = __webpack_require__(29);
	
	var _DetailBack2 = _interopRequireDefault(_DetailBack);
	
	var _DetailItem = __webpack_require__(30);
	
	var _DetailItem2 = _interopRequireDefault(_DetailItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Species = exports.Species = function (_Component) {
	  _inherits(Species, _Component);
	
	  function Species(props) {
	    _classCallCheck(this, Species);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Species).call(this, props));
	
	    _this.fields = {
	      name: 'Name',
	      classification: 'Classification',
	      designation: 'Designation',
	      average_height: 'Average Height',
	      skin_colors: 'Skin Colors',
	      hair_colors: 'Hair Colors',
	      eye_colors: 'Eye Colors',
	      average_lifespan: 'Average Lifespan',
	      homeworld: 'Homeworld',
	      language: 'Language',
	      people: 'People',
	      films: 'Films'
	    };
	    return _this;
	  }
	
	  _createClass(Species, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var id = this.props.routeParams.id;
	
	      this.props.dispatch((0, _speciesesActions.fetchSpecies)(id));
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      _reactRouter.browserHistory.goBack();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (this.props.specieses.isFetching) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          'Loading species data...'
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'species' },
	          _react2.default.createElement(_DetailBack2.default, { onClick: this.goBack }),
	          Object.keys(this.fields).map(function (k, i) {
	            return _react2.default.createElement(_DetailItem2.default, {
	              key: i,
	              data: _this2.props.specieses.detail[k],
	              title: _this2.fields[k] });
	          })
	        );
	      }
	    }
	  }]);
	
	  return Species;
	}(_react.Component);
	
	Species.propTypes = {
	  routeParams: _react.PropTypes.object,
	  dispatch: _react.PropTypes.func,
	  specieses: _react.PropTypes.object
	};
	
	function mapStateToProps(state) {
	  return {
	    specieses: state.specieses
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Species);

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Specieses = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactRouter = __webpack_require__(6);
	
	var _reactInfinite = __webpack_require__(26);
	
	var _reactInfinite2 = _interopRequireDefault(_reactInfinite);
	
	var _ListHeader = __webpack_require__(31);
	
	var _ListHeader2 = _interopRequireDefault(_ListHeader);
	
	var _ListItem = __webpack_require__(32);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _ListItemLoader = __webpack_require__(33);
	
	var _ListItemLoader2 = _interopRequireDefault(_ListItemLoader);
	
	var _Loader = __webpack_require__(24);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Specieses = exports.Specieses = function (_Component) {
	  _inherits(Specieses, _Component);
	
	  function Specieses(props) {
	    _classCallCheck(this, Specieses);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Specieses).call(this, props));
	
	    _this.fields = {
	      name: 'Name'
	    };
	
	    _this.state = {
	      isFetchingMore: false,
	      current: 1,
	      maxItem: 20
	    };
	    return _this;
	  }
	
	  _createClass(Specieses, [{
	    key: 'onRowClick',
	    value: function onRowClick(id) {
	      _reactRouter.browserHistory.push({
	        pathname: 'species/' + id
	      });
	    }
	  }, {
	    key: 'onInfiniteLoad',
	    value: function onInfiniteLoad() {
	      var _this2 = this;
	
	      if (this.props.base.species.length > this.state.maxItem * this.state.current) {
	        this.setState({
	          isFetchingMore: true
	        }, function () {
	          setTimeout(function () {
	            _this2.setState({
	              current: _this2.state.current + 1,
	              isFetchingMore: false
	            });
	          }, 1000);
	        });
	      } else {
	        this.setState({
	          isFetchingMore: false
	        });
	      }
	    }
	  }, {
	    key: 'getLoader',
	    value: function getLoader() {
	      return _react2.default.createElement(_ListItemLoader2.default, { text: 'Loading more species...' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      if (this.props.base.isFetching) {
	        return _react2.default.createElement(_Loader2.default, null);
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'specieses' },
	          _react2.default.createElement(_ListHeader2.default, { fields: this.fields }),
	          _react2.default.createElement(
	            _reactInfinite2.default,
	            {
	              containerHeight: 500,
	              infiniteLoadBeginEdgeOffset: 200,
	              elementHeight: 40,
	              className: 'infiniteScrollContainer',
	              useWindowAsScrollContainer: true,
	              onInfiniteLoad: this.onInfiniteLoad.bind(this),
	              loadingSpinnerDelegate: this.getLoader(),
	              isInfiniteLoading: this.state.isFetchingMore
	            },
	            Object.keys(this.props.base.species).filter(function (species, i) {
	              return i < _this3.state.maxItem * _this3.state.current;
	            }).map(function (species, i) {
	              return _react2.default.createElement(_ListItem2.default, { key: i, fields: _this3.fields, id: species, name: _this3.props.base.species[species], onClick: _this3.onRowClick.bind(_this3) });
	            })
	          )
	        );
	      }
	    }
	  }]);
	
	  return Specieses;
	}(_react.Component);
	
	Specieses.propTypes = {
	  base: _react.PropTypes.object
	};
	
	function mapStateToProps(state) {
	  return {
	    base: state.base
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Specieses);

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Starship = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactRouter = __webpack_require__(6);
	
	var _starshipsActions = __webpack_require__(167);
	
	var _DetailBack = __webpack_require__(29);
	
	var _DetailBack2 = _interopRequireDefault(_DetailBack);
	
	var _DetailItem = __webpack_require__(30);
	
	var _DetailItem2 = _interopRequireDefault(_DetailItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Starship = exports.Starship = function (_Component) {
	  _inherits(Starship, _Component);
	
	  function Starship(props) {
	    _classCallCheck(this, Starship);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Starship).call(this, props));
	
	    _this.fields = {
	      name: 'Name',
	      model: 'Model',
	      manufacturer: 'Manufacturer',
	      cost_in_credits: 'Cost in Credits',
	      length: 'Length',
	      max_atmosphering_speed: 'Max Atmosphering Speed',
	      crew: 'Crew',
	      passengers: 'Passengers',
	      cargo_capacity: 'Cargo Capacity',
	      consumables: 'Consumables',
	      hyperdrive_rating: 'Hyperdrive Rating',
	      MGLT: 'MGLT',
	      starship_class: 'Starship Class',
	      pilots: 'Pilots',
	      films: 'Films'
	    };
	    return _this;
	  }
	
	  _createClass(Starship, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var id = this.props.routeParams.id;
	
	      this.props.dispatch((0, _starshipsActions.fetchStarship)(id));
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      _reactRouter.browserHistory.goBack();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (this.props.starships.isFetching) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          'Loading starship data...'
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'starship' },
	          _react2.default.createElement(_DetailBack2.default, { onClick: this.goBack }),
	          Object.keys(this.fields).map(function (k, i) {
	            return _react2.default.createElement(_DetailItem2.default, {
	              key: i,
	              data: _this2.props.starships.detail[k],
	              title: _this2.fields[k] });
	          })
	        );
	      }
	    }
	  }]);
	
	  return Starship;
	}(_react.Component);
	
	Starship.propTypes = {
	  routeParams: _react.PropTypes.object,
	  dispatch: _react.PropTypes.func,
	  starships: _react.PropTypes.object
	};
	
	function mapStateToProps(state) {
	  return {
	    starships: state.starships
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Starship);

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Starships = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactRouter = __webpack_require__(6);
	
	var _reactInfinite = __webpack_require__(26);
	
	var _reactInfinite2 = _interopRequireDefault(_reactInfinite);
	
	var _ListHeader = __webpack_require__(31);
	
	var _ListHeader2 = _interopRequireDefault(_ListHeader);
	
	var _ListItem = __webpack_require__(32);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _ListItemLoader = __webpack_require__(33);
	
	var _ListItemLoader2 = _interopRequireDefault(_ListItemLoader);
	
	var _Loader = __webpack_require__(24);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Starships = exports.Starships = function (_Component) {
	  _inherits(Starships, _Component);
	
	  function Starships(props) {
	    _classCallCheck(this, Starships);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Starships).call(this, props));
	
	    _this.fields = {
	      name: 'Name'
	    };
	
	    _this.state = {
	      isFetchingMore: false,
	      current: 1,
	      maxItem: 20
	    };
	    return _this;
	  }
	
	  _createClass(Starships, [{
	    key: 'onRowClick',
	    value: function onRowClick(id) {
	      _reactRouter.browserHistory.push({
	        pathname: 'starships/' + id
	      });
	    }
	  }, {
	    key: 'onInfiniteLoad',
	    value: function onInfiniteLoad() {
	      var _this2 = this;
	
	      if (Object.keys(this.props.base.starships).length > this.state.maxItem * this.state.current) {
	        this.setState({
	          isFetchingMore: true
	        }, function () {
	          setTimeout(function () {
	            _this2.setState({
	              current: _this2.state.current + 1,
	              isFetchingMore: false
	            });
	          }, 1000);
	        });
	      } else {
	        this.setState({
	          isFetchingMore: false
	        });
	      }
	    }
	  }, {
	    key: 'getLoader',
	    value: function getLoader() {
	      return _react2.default.createElement(_ListItemLoader2.default, { text: 'Loading more starships...' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      if (this.props.base.isFetching) {
	        return _react2.default.createElement(_Loader2.default, null);
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'starships' },
	          _react2.default.createElement(_ListHeader2.default, { fields: this.fields }),
	          _react2.default.createElement(
	            _reactInfinite2.default,
	            {
	              containerHeight: 500,
	              infiniteLoadBeginEdgeOffset: 200,
	              elementHeight: 40,
	              className: 'infiniteScrollContainer',
	              useWindowAsScrollContainer: true,
	              onInfiniteLoad: this.onInfiniteLoad.bind(this),
	              loadingSpinnerDelegate: this.getLoader(),
	              isInfiniteLoading: this.state.isFetchingMore
	            },
	            Object.keys(this.props.base.starships).filter(function (starship, i) {
	              return i < _this3.state.maxItem * _this3.state.current;
	            }).map(function (starship, i) {
	              return _react2.default.createElement(_ListItem2.default, { key: i, fields: _this3.fields, id: starship, name: _this3.props.base.starships[starship], onClick: _this3.onRowClick.bind(_this3) });
	            })
	          )
	        );
	      }
	    }
	  }]);
	
	  return Starships;
	}(_react.Component);
	
	Starships.propTypes = {
	  base: _react.PropTypes.object
	};
	
	function mapStateToProps(state) {
	  return {
	    base: state.base
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Starships);

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Vehicle = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactRouter = __webpack_require__(6);
	
	var _vehiclesActions = __webpack_require__(168);
	
	var _DetailBack = __webpack_require__(29);
	
	var _DetailBack2 = _interopRequireDefault(_DetailBack);
	
	var _DetailItem = __webpack_require__(30);
	
	var _DetailItem2 = _interopRequireDefault(_DetailItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Vehicle = exports.Vehicle = function (_Component) {
	  _inherits(Vehicle, _Component);
	
	  function Vehicle(props) {
	    _classCallCheck(this, Vehicle);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Vehicle).call(this, props));
	
	    _this.fields = {
	      name: 'Name',
	      model: 'Model',
	      manufacturer: 'Manufacturer',
	      cost_in_credits: 'Cost in Credits',
	      length: 'Length',
	      max_atmosphering_speed: 'Max Atmosphering Speed',
	      crew: 'Crew',
	      passengers: 'Passengers',
	      cargo_capacity: 'Cargo Capacity',
	      consumables: 'Consumables',
	      vehicle_class: 'Vehicle Class',
	      pilots: 'Pilots',
	      films: 'Films'
	    };
	    return _this;
	  }
	
	  _createClass(Vehicle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var id = this.props.routeParams.id;
	
	      this.props.dispatch((0, _vehiclesActions.fetchVehicle)(id));
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      _reactRouter.browserHistory.goBack();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (this.props.vehicles.isFetching) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          'Loading vehicle data...'
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'vehicle' },
	          _react2.default.createElement(_DetailBack2.default, { onClick: this.goBack }),
	          Object.keys(this.fields).map(function (k, i) {
	            return _react2.default.createElement(_DetailItem2.default, {
	              key: i,
	              data: _this2.props.vehicles.detail[k],
	              title: _this2.fields[k] });
	          })
	        );
	      }
	    }
	  }]);
	
	  return Vehicle;
	}(_react.Component);
	
	Vehicle.propTypes = {
	  routeParams: _react.PropTypes.object,
	  dispatch: _react.PropTypes.func,
	  vehicles: _react.PropTypes.object
	};
	
	function mapStateToProps(state) {
	  return {
	    vehicles: state.vehicles
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Vehicle);

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Vehicles = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(9);
	
	var _reactRouter = __webpack_require__(6);
	
	var _reactInfinite = __webpack_require__(26);
	
	var _reactInfinite2 = _interopRequireDefault(_reactInfinite);
	
	var _ListHeader = __webpack_require__(31);
	
	var _ListHeader2 = _interopRequireDefault(_ListHeader);
	
	var _ListItem = __webpack_require__(32);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _ListItemLoader = __webpack_require__(33);
	
	var _ListItemLoader2 = _interopRequireDefault(_ListItemLoader);
	
	var _Loader = __webpack_require__(24);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Vehicles = exports.Vehicles = function (_Component) {
	  _inherits(Vehicles, _Component);
	
	  function Vehicles(props) {
	    _classCallCheck(this, Vehicles);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Vehicles).call(this, props));
	
	    _this.fields = {
	      name: 'Name'
	    };
	
	    _this.state = {
	      isFetchingMore: false,
	      current: 1,
	      maxItem: 20
	    };
	    return _this;
	  }
	
	  _createClass(Vehicles, [{
	    key: 'onRowClick',
	    value: function onRowClick(id) {
	      _reactRouter.browserHistory.push({
	        pathname: 'vehicles/' + id
	      });
	    }
	  }, {
	    key: 'onInfiniteLoad',
	    value: function onInfiniteLoad() {
	      var _this2 = this;
	
	      if (this.props.base.vehicles.length > this.state.maxItem * this.state.current) {
	        this.setState({
	          isFetchingMore: true
	        }, function () {
	          setTimeout(function () {
	            _this2.setState({
	              current: _this2.state.current + 1,
	              isFetchingMore: false
	            });
	          }, 1000);
	        });
	      } else {
	        this.setState({
	          isFetchingMore: false
	        });
	      }
	    }
	  }, {
	    key: 'getLoader',
	    value: function getLoader() {
	      return _react2.default.createElement(_ListItemLoader2.default, { text: 'Loading more vehicles...' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      if (this.props.base.isFetching) {
	        return _react2.default.createElement(_Loader2.default, null);
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'vehicles' },
	          _react2.default.createElement(_ListHeader2.default, { fields: this.fields }),
	          _react2.default.createElement(
	            _reactInfinite2.default,
	            {
	              containerHeight: 500,
	              infiniteLoadBeginEdgeOffset: 200,
	              elementHeight: 40,
	              className: 'infiniteScrollContainer',
	              useWindowAsScrollContainer: true,
	              onInfiniteLoad: this.onInfiniteLoad.bind(this),
	              loadingSpinnerDelegate: this.getLoader(),
	              isInfiniteLoading: this.state.isFetchingMore
	            },
	            Object.keys(this.props.base.vehicles).filter(function (vehicle, i) {
	              return i < _this3.state.maxItem * _this3.state.current;
	            }).map(function (vehicle, i) {
	              return _react2.default.createElement(_ListItem2.default, { key: i, fields: _this3.fields, id: vehicle, name: _this3.props.base.vehicles[vehicle], onClick: _this3.onRowClick.bind(_this3) });
	            })
	          )
	        );
	      }
	    }
	  }]);
	
	  return Vehicles;
	}(_react.Component);
	
	Vehicles.propTypes = {
	  base: _react.PropTypes.object
	};
	
	function mapStateToProps(state) {
	  return {
	    base: state.base
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Vehicles);

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = baseReducer;
	
	var _actionTypes = __webpack_require__(11);
	
	var initialState = {
	  isFetching: false
	};
	
	function baseReducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	
	    case _actionTypes.FETCH_BASE_START:
	      return Object.assign({}, state, {
	        isFetching: true
	      });
	
	    case _actionTypes.FETCH_BASE_DONE:
	      return Object.assign({}, state, {
	        isFetching: false
	      });
	
	    case _actionTypes.RECEIVE_BASE:
	      return Object.assign({}, state, action.base);
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = filmsReducer;
	
	var _actionTypes = __webpack_require__(11);
	
	var initialState = {
	  isFetching: false,
	  isFetchingMore: false,
	  data: {
	    count: '',
	    next: '',
	    previous: '',
	    results: []
	  },
	  detail: {}
	};
	
	function filmsReducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actionTypes.FETCH_FILMS_START:
	      return Object.assign({}, state, {
	        isFetching: true
	      });
	
	    case _actionTypes.FETCH_FILMS_DONE:
	      return Object.assign({}, state, {
	        isFetching: false
	      });
	
	    case _actionTypes.RECEIVE_FILMS:
	      return Object.assign({}, state, {
	        isFetching: false,
	        data: action.data
	      });
	
	    case _actionTypes.FETCH_FILM_START:
	      return Object.assign({}, state, {
	        isFetching: true
	      });
	
	    case _actionTypes.FETCH_FILM_DONE:
	      return Object.assign({}, state, {
	        isFetching: false
	      });
	
	    case _actionTypes.RECEIVE_FILM:
	      return Object.assign({}, state, {
	        detail: action.detail
	      });
	
	    case _actionTypes.FETCH_MORE_FILMS_START:
	      return Object.assign({}, state, {
	        isFetchingMore: true
	      });
	
	    case _actionTypes.FETCH_MORE_FILMS_DONE:
	      return Object.assign({}, state, {
	        isFetchingMore: false
	      });
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(56);
	
	var _reactRouterRedux = __webpack_require__(61);
	
	var _baseReducer = __webpack_require__(185);
	
	var _baseReducer2 = _interopRequireDefault(_baseReducer);
	
	var _filmsReducer = __webpack_require__(186);
	
	var _filmsReducer2 = _interopRequireDefault(_filmsReducer);
	
	var _peopleReducer = __webpack_require__(188);
	
	var _peopleReducer2 = _interopRequireDefault(_peopleReducer);
	
	var _planetsReducer = __webpack_require__(189);
	
	var _planetsReducer2 = _interopRequireDefault(_planetsReducer);
	
	var _speciesesReducer = __webpack_require__(190);
	
	var _speciesesReducer2 = _interopRequireDefault(_speciesesReducer);
	
	var _starshipsReducer = __webpack_require__(191);
	
	var _starshipsReducer2 = _interopRequireDefault(_starshipsReducer);
	
	var _vehiclesReducer = __webpack_require__(192);
	
	var _vehiclesReducer2 = _interopRequireDefault(_vehiclesReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rootReducer = (0, _redux.combineReducers)({
	  base: _baseReducer2.default,
	  films: _filmsReducer2.default,
	  people: _peopleReducer2.default,
	  planets: _planetsReducer2.default,
	  specieses: _speciesesReducer2.default,
	  starships: _starshipsReducer2.default,
	  vehicles: _vehiclesReducer2.default,
	  routing: _reactRouterRedux.routerReducer
	});
	
	exports.default = rootReducer;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = peopleReducer;
	
	var _actionTypes = __webpack_require__(11);
	
	var initialState = {
	  isFetching: false,
	  isFetchingMore: false,
	  data: {
	    count: '',
	    next: '',
	    previous: '',
	    results: []
	  },
	  detail: {}
	};
	
	function peopleReducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actionTypes.FETCH_PEOPLE_START:
	      return Object.assign({}, state, {
	        isFetching: true
	      });
	
	    case _actionTypes.FETCH_PEOPLE_DONE:
	      return Object.assign({}, state, {
	        isFetching: false
	      });
	
	    case _actionTypes.RECEIVE_PEOPLE:
	      return Object.assign({}, state, {
	        data: action.data
	      });
	
	    case _actionTypes.FETCH_PERSON_START:
	      return Object.assign({}, state, {
	        isFetching: true
	      });
	
	    case _actionTypes.FETCH_PERSON_DONE:
	      return Object.assign({}, state, {
	        isFetching: false
	      });
	
	    case _actionTypes.RECEIVE_PERSON:
	      return Object.assign({}, state, {
	        detail: action.detail
	      });
	
	    case _actionTypes.FETCH_MORE_PEOPLE_START:
	      return Object.assign({}, state, {
	        isFetchingMore: true
	      });
	
	    case _actionTypes.FETCH_MORE_PEOPLE_DONE:
	      return Object.assign({}, state, {
	        isFetchingMore: false
	      });
	
	    case _actionTypes.RECEIVE_MORE_PEOPLE:
	      return Object.assign({}, state, {
	        data: {
	          count: action.data.count,
	          next: action.data.next,
	          prev: action.data.prev,
	          results: state.data.results.concat(action.data.results)
	        }
	      });
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = planet;
	
	var _actionTypes = __webpack_require__(11);
	
	var initialState = {
	  isFetching: false,
	  data: {
	    count: '',
	    next: '',
	    previous: '',
	    results: []
	  },
	  detail: {}
	};
	
	function planet() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actionTypes.FETCH_PLANETS_START:
	      return Object.assign({}, state, {
	        isFetching: true
	      });
	
	    case _actionTypes.FETCH_PLANETS_DONE:
	      return Object.assign({}, state, {
	        isFetching: false
	      });
	
	    case _actionTypes.RECEIVE_PLANETS:
	      return Object.assign({}, state, {
	        isFetching: false,
	        data: action.data
	      });
	
	    case _actionTypes.FETCH_PLANET_START:
	      return Object.assign({}, state, {
	        isFetching: true
	      });
	
	    case _actionTypes.FETCH_PLANET_DONE:
	      return Object.assign({}, state, {
	        isFetching: false
	      });
	
	    case _actionTypes.RECEIVE_PLANET:
	      return Object.assign({}, state, {
	        detail: action.detail
	      });
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = speciesesReducer;
	
	var _actionTypes = __webpack_require__(11);
	
	var initialState = {
	  isFetching: false,
	  data: {
	    count: '',
	    next: '',
	    previous: '',
	    results: []
	  },
	  detail: {}
	};
	
	function speciesesReducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actionTypes.FETCH_SPECIESES_START:
	      return Object.assign({}, state, {
	        isFetching: true
	      });
	
	    case _actionTypes.FETCH_SPECIESES_DONE:
	      return Object.assign({}, state, {
	        isFetching: false
	      });
	
	    case _actionTypes.RECEIVE_SPECIESES:
	      return Object.assign({}, state, {
	        isFetching: false,
	        data: action.data
	      });
	
	    case _actionTypes.FETCH_SPECIES_START:
	      return Object.assign({}, state, {
	        isFetching: true
	      });
	
	    case _actionTypes.FETCH_SPECIES_DONE:
	      return Object.assign({}, state, {
	        isFetching: false
	      });
	
	    case _actionTypes.RECEIVE_SPECIES:
	      return Object.assign({}, state, {
	        detail: action.detail
	      });
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = starshipsReducer;
	
	var _actionTypes = __webpack_require__(11);
	
	var initialState = {
	  isFetching: false,
	  data: {
	    count: '',
	    next: '',
	    previous: '',
	    results: []
	  },
	  detail: {}
	};
	
	function starshipsReducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actionTypes.FETCH_STARSHIPS_START:
	      return Object.assign({}, state, {
	        isFetching: true
	      });
	
	    case _actionTypes.FETCH_STARSHIPS_DONE:
	      return Object.assign({}, state, {
	        isFetching: false
	      });
	
	    case _actionTypes.RECEIVE_STARSHIPS:
	      return Object.assign({}, state, {
	        isFetching: false,
	        data: action.data
	      });
	
	    case _actionTypes.FETCH_STARSHIP_START:
	      return Object.assign({}, state, {
	        isFetching: true
	      });
	
	    case _actionTypes.FETCH_STARSHIP_DONE:
	      return Object.assign({}, state, {
	        isFetching: false
	      });
	
	    case _actionTypes.RECEIVE_STARSHIP:
	      return Object.assign({}, state, {
	        detail: action.detail
	      });
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = vehiclesReducer;
	
	var _actionTypes = __webpack_require__(11);
	
	var initialState = {
	  isFetching: false,
	  data: {
	    count: '',
	    next: '',
	    previous: '',
	    results: []
	  },
	  detail: {}
	};
	
	function vehiclesReducer() {
	  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actionTypes.FETCH_VEHICLES_START:
	      return Object.assign({}, state, {
	        isFetching: true
	      });
	
	    case _actionTypes.FETCH_VEHICLES_DONE:
	      return Object.assign({}, state, {
	        isFetching: false
	      });
	
	    case _actionTypes.RECEIVE_VEHICLES:
	      return Object.assign({}, state, {
	        isFetching: false,
	        data: action.data
	      });
	
	    case _actionTypes.FETCH_VEHICLE_START:
	      return Object.assign({}, state, {
	        isFetching: true
	      });
	
	    case _actionTypes.FETCH_VEHICLE_DONE:
	      return Object.assign({}, state, {
	        isFetching: false
	      });
	
	    case _actionTypes.RECEIVE_VEHICLE:
	      return Object.assign({}, state, {
	        detail: action.detail
	      });
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(6);
	
	var _App = __webpack_require__(172);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Films = __webpack_require__(174);
	
	var _Films2 = _interopRequireDefault(_Films);
	
	var _Film = __webpack_require__(173);
	
	var _Film2 = _interopRequireDefault(_Film);
	
	var _People = __webpack_require__(175);
	
	var _People2 = _interopRequireDefault(_People);
	
	var _Person = __webpack_require__(176);
	
	var _Person2 = _interopRequireDefault(_Person);
	
	var _Planets = __webpack_require__(178);
	
	var _Planets2 = _interopRequireDefault(_Planets);
	
	var _Planet = __webpack_require__(177);
	
	var _Planet2 = _interopRequireDefault(_Planet);
	
	var _Specieses = __webpack_require__(180);
	
	var _Specieses2 = _interopRequireDefault(_Specieses);
	
	var _Species = __webpack_require__(179);
	
	var _Species2 = _interopRequireDefault(_Species);
	
	var _Starships = __webpack_require__(182);
	
	var _Starships2 = _interopRequireDefault(_Starships);
	
	var _Starship = __webpack_require__(181);
	
	var _Starship2 = _interopRequireDefault(_Starship);
	
	var _Vehicles = __webpack_require__(184);
	
	var _Vehicles2 = _interopRequireDefault(_Vehicles);
	
	var _Vehicle = __webpack_require__(183);
	
	var _Vehicle2 = _interopRequireDefault(_Vehicle);
	
	var _NotFoundPage = __webpack_require__(170);
	
	var _NotFoundPage2 = _interopRequireDefault(_NotFoundPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createElement(
	  _reactRouter.Route,
	  { path: '/', component: _App2.default },
	  _react2.default.createElement(_reactRouter.IndexRedirect, { to: '/films' }),
	  _react2.default.createElement(_reactRouter.Route, { path: 'films', component: _Films2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: 'films/:id', component: _Film2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: 'people', component: _People2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: 'people/:id', component: _Person2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: 'planets', component: _Planets2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: 'planets/:id', component: _Planet2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: 'species', component: _Specieses2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: 'species/:id', component: _Species2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: 'starships', component: _Starships2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: 'starships/:id', component: _Starship2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: 'vehicles', component: _Vehicles2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: 'vehicles/:id', component: _Vehicle2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: '*', component: _NotFoundPage2.default })
	);

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(195);
	} else {
	  module.exports = require('./configureStore.dev');
	}

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = configureStore;
	
	var _redux = __webpack_require__(56);
	
	var _reducers = __webpack_require__(187);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _reduxThunk = __webpack_require__(143);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function configureStore(initialState) {
	  return (0, _redux.createStore)(_reducers2.default, initialState, (0, _redux.applyMiddleware)(_reduxThunk2.default));
	}

/***/ },
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4adaaf46668cfdc7f20212f91eb7d272.png";

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "favicon.ico";

/***/ }
]);


/** WEBPACK FOOTER **
 ** app.b144a10f38411796d91e.js
 **/